import { Clock } from "lucide-react";
import type { AffiliateRecord } from "@/lib/affiliate";
import { Card, CardContent } from "@/components/ui/card";

interface Props {
  affiliate: AffiliateRecord;
}

export function AffiliatePending({ affiliate }: Props) {
  const submittedDate = new Date(affiliate.createdAt).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardContent className="flex flex-col items-center gap-4 py-10">
          <div className="flex size-14 items-center justify-center rounded-full bg-yellow-500/10">
            <Clock className="size-7 text-yellow-500" />
          </div>
          <div className="text-center">
            <h2 className="text-lg font-semibold">Application Under Review</h2>
            <p className="mt-1.5 text-sm text-muted-foreground max-w-sm">
              Your affiliate application is being reviewed. We'll notify you once a decision has been made.
            </p>
          </div>
          <p className="text-xs text-muted-foreground">Submitted on {submittedDate}</p>
        </CardContent>
      </Card>
    </div>
  );
}
